import "@babel/polyfill";
import Vue from "vue";
import "./plugins/vuetify";
import "./plugins/moment";
import "./plugins/vue-uuid";
import "./plugins/googleAddressAutocomplete";
import "./plugins/vue-croppa";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./registerServiceWorker";
import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.compact.css";
import { auth } from "./firebase.js"

Vue.config.productionTip = false;

auth.onAuthStateChanged(user => {
  new Vue({
    router,
    store,
    async beforeCreate() {
      if (user) {
        await this.$store.dispatch("autoSignIn", user).then(() => {
          this.$store.dispatch("loadAppointments");
        });
      }
    },
    render: h => h(App)
  }).$mount("#app");
});
